export default __webpack_public_path__ + "static/media/MobileText.be15d92f.svg";